import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CardText
} from "reactstrap"
import { SuccessOk, SuccessCreated } from "configs/statusCode"
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import DealService from "services/Provider/DealService"
import FileUpload from "components/Common/file-upload/file-upload.component";

function ModalForm({ modal, toggle, id }) {
    const dealService = new DealService()
    const [loading, setLoading] = useState(false)
    const [uploadState, setUploadState] = useState(false)
    const [mediaIds, setMediaIds] = useState([])
    const updatedAttachment = (attachments, type) => {
        setMediaIds([...mediaIds, ...attachments])
    };

    const deleteAttachment = (Items, type) => {
        let updatedMedia = mediaIds ?.filter(item => item.id != Items[0].id)
            setMediaIds(updatedMedia)
    };

   

   
    const handleValidSubmit = (_, values) => {
        setLoading(true)
         const data = { }
         if(mediaIds?.length){
            data.attachment=mediaIds.map(item => item.path)

         }
        dealService.sendCil(id,data).then(res => {
            if (res && res.status === SuccessOk) {
                setLoading(false)
                toast.success("Email Sent successfully")
                toggle()
            } else {
                setLoading(false)
            }
        })
    }
    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <AvForm
                className='form-horizontal'
                onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v)
                }}>
                <ModalBody className="px-0">
                         <Row className="my-0 p-1 d-flex justify-content-between ">
                            <Col><span className=" font-size-15 fw-bold">Send CIL</span></Col>
                        </Row>
                        {/* <Row >
                         <span className="font-size-13 text-muted px-1">Add title and description to can add feedback</span> 
                        </Row>*/}
                     <hr className="my-0" />
                </ModalBody>
                <Row>
                    <Col md={12}>
                        <FileUpload
                            accept='.jpg,.png,.jpeg,.JPG,.PNG,.JPEG,.pdf,.doc,.docx'
                            label='Upload File (Optional)'
                            attachmentType='media_id'
                            attachmentData={mediaIds}
                            setUpload={()=> {}}
                            updatedAttachment={updatedAttachment}
                            deleteAttachment={deleteAttachment}
                            setUploadState={setUploadState}
                            multiple
                        />
                    </Col>
                </Row>
                <ModalFooter className="p-0 pt-1 m-0 d-flex justify-content-between">
                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-secondary'>
                        Cancel
                        </button>
                    <button
                        type='submit'
                        disabled={uploadState ? true : loading ?  true:false}
                        className='btn btn-success'>
                        Submit
                        </button>
                </ModalFooter>
            </AvForm>
        </Modal>

    )
}

export default ModalForm
